module.exports = __webpack_public_path__ + "static/media/sona-buvelle-lose.95e9a802.png";